export enum ShipmentType {
    Stock = "Stock",
    Emergency = "Emergency",
    Warranty = "Warranty",
    DropShip = "DropShip",
    All = "All",
}
